module.exports = __webpack_public_path__ + "assets/img/ts-0-light.c21a0a19.png";